import { Action } from 'redux';
import { OrderedMap } from 'immutable';

import {
    GET_COMPILATIONS_REQUEST,
    GET_COMPILATIONS_RESPONSE,
    GET_COMPILATIONS_ERROR,

    GET_COMPILATION_EVENTS_REQUEST,
    GET_COMPILATION_EVENTS_RESPONSE,
    GET_MORE_COMPILATION_EVENTS_RESPONSE,
    GET_COMPILATION_EVENTS_ERROR,

    GET_COMPILATION_PLACES_REQUEST,
    GET_COMPILATION_PLACES_RESPONSE,
    GET_MORE_COMPILATION_PLACES_RESPONSE,
    GET_COMPILATION_PLACES_ERROR,

    RESET_EVENTS,
    RESET_PLACES,

    SEARCH_EVENTS_REQUEST,
    SEARCH_EVENTS_RESPONSE,
    SEARCH_EVENTS_ERROR,

    SEARCH_PLACES_REQUEST,
    SEARCH_PLACES_RESPONSE,
    SEARCH_PLACES_ERROR,

    SET_PLACE_QUERY,
    SET_EVENT_QUERY,
} from '../../actions/Afisha/compilation';

import { Event } from '../../models/Afisha/Event';
import { Place } from '../../models/Afisha/Place';
import { Compilation } from '../../models/Afisha/Compilation';

export interface CompilationAfishaState {
    compilationEvents: OrderedMap<number, Event>;
    loadingCompilationEvents: boolean;
    errorCompilationEvents: any;

    compilationPlaces: OrderedMap<number, Place>;
    loadingCompilationPlaces: boolean;
    errorCompilationPlaces: any;

    pageCompilationEvents: number;
    pageCompilationPlaces: number;

    compilations: OrderedMap<number, Compilation>;
    loadingCompilations: boolean;
    errorCompilations: any;

    numberOfCompilation: number;

    eventQuery: string;
    placeQuery: string;
}

const initialState: CompilationAfishaState = {
    compilationEvents: OrderedMap<number, Event>(),
    loadingCompilationEvents: false,
    errorCompilationEvents: null,

    compilationPlaces: OrderedMap<number, Place>(),
    loadingCompilationPlaces: false,
    errorCompilationPlaces: null,

    pageCompilationEvents: 1,
    pageCompilationPlaces: 1,

    compilations: OrderedMap<number, Compilation>(),
    loadingCompilations: false,
    errorCompilations: null,

    numberOfCompilation: 0,

    eventQuery: '',
    placeQuery: '',
};

export function compilationAfisha(state: CompilationAfishaState = initialState, action: Action) {
    switch (action.type) {
        case GET_COMPILATION_EVENTS_REQUEST: {
            return {
                ...state,
                loadingCompilationEvents: state.compilationEvents.size === 0,
                errorCompilationEvents: null
            };
        }
        case GET_MORE_COMPILATION_EVENTS_RESPONSE: {
            const result = (action as any).response.result;
            const compilationEvents = (result.events as Array<Event>).reduce((prev, cur) => {
                prev = prev.has(cur.id) ? prev : prev.set(cur.id, cur);
                return prev;
            }, state.compilationEvents);
            return {
                ...state,
                loadingCompilationEvents: false,
                compilationEvents,
                pageCompilationEvents: result.pagination.next_page,
                numberOfCompilation: result.pagination.total_count
            };
        }
        case GET_COMPILATION_EVENTS_RESPONSE: {
            const result = (action as any).response.result.events;
            const compilationEvents = (result as Array<Event>).reduce((prev, cur) => {
                prev = prev.has(cur.id) ? prev : prev.set(cur.id, cur);
                return prev;
            }, OrderedMap<number, Event>());
            return {
                ...state,
                loadingCompilationEvents: false,
                compilationEvents,
                pageCompilationEvents: (action as any).response.result.pagination.next_page,
                numberOfCompilation: (action as any).response.result.pagination.total_count
            };
        }
        case GET_COMPILATION_EVENTS_ERROR: {
            const errorCompilationEvents = (action as any).error;
            return {
                ...state,
                loadingCompilationEvents: false,
                errorCompilationEvents
            };
        }

        case GET_COMPILATION_PLACES_REQUEST: {
            return {
                ...state,
                loadingCompilationPlaces: state.compilationPlaces.size === 0,
                errorCompilationPlaces: null
            };
        }
        case GET_MORE_COMPILATION_PLACES_RESPONSE: {
            const result = (action as any).response.result;
            const compilationPlaces = (result.places as Array<Place>).reduce((prev, cur) => {
                prev = prev.has(cur.id) ? prev : prev.set(cur.id, cur);
                return prev;
            }, state.compilationPlaces);
            return {
                ...state,
                loadingCompilationPlaces: false,
                compilationPlaces,
                pageCompilationPlaces: result.pagination.next_page,
                numberOfCompilation: result.pagination.total_count
            };
        }
        case GET_COMPILATION_PLACES_RESPONSE: {
            const result = (action as any).response.result;
            const compilationPlaces = (result.places as Array<Place>).reduce((prev, cur) => {
                prev = prev.has(cur.id) ? prev : prev.set(cur.id, cur);
                return prev;
            }, OrderedMap<number, Place>());
            return {
                ...state,
                loadingCompilationPlaces: false,
                compilationPlaces,
                pageCompilationPlaces: result.pagination.next_page,
                numberOfCompilation: result.pagination.total_count
            };
        }
        case GET_COMPILATION_PLACES_ERROR: {
            const errorCompilationPlaces = (action as any).error;
            return {
                ...state,
                loadingCompilationPlaces: false,
                errorCompilationPlaces
            };
        }

        case GET_COMPILATIONS_REQUEST: {
            return {
                ...state,
                loadingCompilations: true,
                errorCompilations: initialState.errorCompilations,
                compilations: initialState.compilations
            };
        }
        case GET_COMPILATIONS_RESPONSE: {
            const result: Compilation[] = (action as any).response.result;
            const compilations = result.reduce((prev, cur) => prev.set(cur.id, cur), initialState.compilations);
            return {
                ...state,
                loadingCompilations: false,
                compilations
            };
        }
        case GET_COMPILATIONS_ERROR: {
            const errorCompilations = (action as any).error;
            return {
                ...state,
                loadingCompilations: false,
                errorCompilations
            };
        }

        case RESET_EVENTS: {
            return {
                ...state,
                loadingCompilationEvents: false,
                errorCompilationEvents: initialState.errorCompilationEvents,
                compilationEvents: initialState.compilationEvents,
                pageCompilationEvents: initialState.pageCompilationEvents,
                numberOfCompilation: initialState.numberOfCompilation,
                eventQuery: initialState.eventQuery,
            };
        }
        case RESET_PLACES: {
            return {
                ...state,
                loadingCompilationPlaces: false,
                errorCompilationPlaces: initialState.errorCompilationPlaces,
                compilationPlaces: initialState.compilationPlaces,
                pageCompilationPlaces: initialState.pageCompilationPlaces,
                numberOfCompilation: initialState.numberOfCompilation,
                placeQuery: initialState.placeQuery,
            };
        }

        case SEARCH_EVENTS_REQUEST: {
            return {
                ...state,
                loadingCompilationEvents: true,
                errorCompilationEvents: initialState.errorCompilationEvents,
            };
        }
        case SEARCH_EVENTS_RESPONSE: {
            const result: Event[] = (action as any).response.result;
            const compilationEvents = result.reduce((prev, cur) => prev.has(cur.id) ? prev : prev.set(cur.id, cur), OrderedMap<number, Event>());
            return {
                ...state,
                loadingCompilationEvents: false,
                compilationEvents,
                numberOfCompilation: compilationEvents.size,
                pageCompilationEvents: null,
            };
        }
        case SEARCH_EVENTS_ERROR: {
            const errorCompilationEvents = (action as any).error;
            return {
                ...state,
                loadingCompilationEvents: false,
                errorCompilationEvents,
            };
        }

        case SEARCH_PLACES_REQUEST: {
            return {
                ...state,
                loadingCompilationPlaces: true,
                errorCompilationPlaces: initialState.errorCompilationPlaces,
            };
        }
        case SEARCH_PLACES_RESPONSE: {
            const result: Place[] = (action as any).response.result;
            const compilationPlaces = result.reduce((prev, cur) => prev.has(cur.id) ? prev : prev.set(cur.id, cur), OrderedMap<number, Place>());
            return {
                ...state,
                loadingCompilationPlaces: false,
                compilationPlaces,
                numberOfCompilation: compilationPlaces.size,
                pageCompilationPlaces: null,
            };
        }
        case SEARCH_PLACES_ERROR: {
            const errorCompilationPlaces = (action as any).error;
            return {
                ...state,
                loadingCompilationPlaces: false,
                errorCompilationPlaces,
            };
        }

        case SET_EVENT_QUERY: {
            const eventQuery = (action as any).query;
            return {
                ...state,
                eventQuery,
            };
        }
        case SET_PLACE_QUERY: {
            const placeQuery = (action as any).query;
            return {
                ...state,
                placeQuery,
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/Afisha/compilation.ts